import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../hooks/useStores";
import {Trans, useTranslation} from "react-i18next";
import {isYoungProfile} from "../utils/parsers";
import ProfileInfo from '../components/ProfileInfo';
import ProfileConfig from '../components/ProfileConfig';
import {Link} from "react-router-dom";
import {MENU} from "../utils/constants";

const Profile = observer(() => {
    const {t} = useTranslation();
    const {myTibStore, notificationStore} = useStores();
    const {notifications} = notificationStore;
    const {settings, profile} = myTibStore;

    const isYoungUserProfile = isYoungProfile(profile.birthday);

    // forced false for desable feature
    const showStudentProfileClaim = (isYoungUserProfile: boolean, isStudent: boolean): false => {
        if (isYoungUserProfile && !isStudent) {
            return false;
        } else {
            return false;
        }
    }

    let showStudentClaim = false;
    if (settings !== undefined) {
        showStudentClaim = showStudentProfileClaim(isYoungUserProfile, settings.isStudent);
    } else {
        console.error('settings is undefined');
    }
    return (
        <div data-testid="profile" className="profile-page">
            <div className="page-title-mobile">
                {t("profile")}
            </div>
            <div className="favs-container profile">
                <ProfileInfo profile={profile} notifications={notifications}/>
                <ProfileConfig settings={settings}/>
            </div>

            {showStudentClaim && (
                <div className="checks-title student-profile-container" role="alert">
                    <Trans i18nKey="student_profile_confirm.student_profile_go_to_form"
                           components={{
                               1:
                                   <Link to={MENU.STUDENT_YOUNG_PROFILE_CONFIRM_FORM.URL}/>
                           }}/>
                </div>
            )}
        </div>
    );
});

export default Profile;